import { get, postJSON } from "api/http"
import { contractsURL } from "api/urls"
import { clearAuthenticated } from "store/app/actions"
import { v4 as uuidv4 } from "uuid"
import { toast } from "react-toastify"

// FETCH_CONTRACTS

export const fetchContractsStart = () => ({
  type: "FETCH_CONTRACTS_START",
})

export const fetchContractsSuccess = (payload) => ({
  type: "FETCH_CONTRACTS_SUCCESS",
  payload,
})

export const fetchContractsError = (payload) => ({
  type: "FETCH_CONTRACTS_ERROR",
  payload,
})

export const fetchContracts = () => async (dispatch, getState) => {
  try {
    dispatch(fetchContractsStart())
    const response = await get(contractsURL())
    const json = await response.json()

    if (response.status === 200 && response.redirected === false) {
      dispatch(fetchContractsSuccess(json.entries || []))
    } else {
      if (response.status === 403 || response.redirected === true) {
        dispatch(clearAuthenticated())
      }

      dispatch(fetchContractsError(json))
    }
  } catch (e) {
    dispatch(fetchContractsError(e))
  }
}

// ADD_CONTRACT

export const addContractStart = (payload) => ({
  type: "ADD_CONTRACT_START",
  payload,
})

export const addContractSuccess = (payload) => ({
  type: "ADD_CONTRACT_SUCCESS",
  payload,
})

export const addContractError = (payload) => ({
  type: "ADD_CONTRACT_ERROR",
  payload,
})

export const addContract = (entry) => async (dispatch, getState) => {
  const { entries } = getState().garage

  if (entries && entries.length > 32) {
    toast.error("Shranjenih imate lahko največ 32 pogodb.", {
      position: toast.POSITION.BOTTOM_CENTER,
      hideProgressBar: true,
    })

    return false
  }

  // if (entries.find((e) => e.vin === entry.vin)) {
  //   dispatch(addContractSuccess(entries))

  //   return entries
  // }

  const body = {
    entries: [...entries, { id: uuidv4(), ...entry }],
  }

  try {
    dispatch(addContractStart(entry))
    const response = await postJSON(contractsURL(), { body: body })
    const json = await response.json()

    if (response.status === 200 || response.status === 201) {
      dispatch(addContractSuccess(body.entries))
    } else {
      if (response.status === 403) {
        dispatch(clearAuthenticated())
      }

      dispatch(addContractError(json))
    }
  } catch (e) {
    dispatch(addContractError(e))
  }
}
